import BadgeEdit from '@/screens/BadgeEdit';

export default function PrivateBadgeCreateIndexRoute() {
  return <BadgeEdit />;
}
